<script>
  import { updateClasses, cssPrefix } from '../helper-classes.js'

  export let selected = false
  export let disabled = false
  export let label = false

  let classes = [`${cssPrefix}tab-item`]

  $: classes = updateClasses(classes, selected, 'is-selected')
  $: classes = updateClasses(classes, disabled, 'is-disabled')
  $: classes = updateClasses(classes, label, 'is-label')
</script>

<li class={classes.join(' ')}>
  <slot />
</li>
